import {WorkrequestViewmodelBase} from '../../shared/viewmodels/workrequest-viewmodel-base';
import {WorkrequestChmDetails} from './workrequest-chm-details';


export class WorkrequestChmViewmodel extends WorkrequestViewmodelBase {
  workrequestDetails: WorkrequestChmDetails;
  applicationFeeAmount: number;
  waterMeterFeeAmount = 0;
  remoteWaterMeterFeeAmount = 0;

  waterMetersAmount: number;
  remoteWaterMetersAmount: number;
  finalTotal: number;
  newCheckMeterLocation: string;

  private _bodyCorporateYes: boolean;
  private _bodyCorporateNo: boolean;
  private _commonWaterUseNo: boolean;
  private _commonWaterUseYes: boolean;
  invalidSelectionError = 'Please add at least one meter';
  errorMessage: string;
  invalidDevelopmentTypeError = 'Please select an option which best describes the metering requirements';



  constructor() {
    super();
    this.workrequestDetails = new WorkrequestChmDetails();
  }

  calculateTotal(): void {
    this.waterMetersAmount = this.workrequestDetails.numberOfWaterMeters * this.waterMeterFeeAmount;
    this.remoteWaterMetersAmount = this.workrequestDetails.numberOfRemoteWaterMeters * this.remoteWaterMeterFeeAmount;
    this.finalTotal = this.waterMetersAmount + this.remoteWaterMetersAmount + this.applicationFeeAmount;
  }

  get bodyCorporateYes(): boolean {
    return this._bodyCorporateYes;
  }

  set bodyCorporateYes(v: boolean) {
    this._bodyCorporateYes = v;
    this.workrequestDetails.bodyCorporate = v;
    if (v) {
      this._bodyCorporateNo = false;
    }
  }

  get bodyCorporateNo(): boolean {
    return this._bodyCorporateNo;
  }

  set bodyCorporateNo(v: boolean) {
    this._bodyCorporateNo = v;
    this.workrequestDetails.bodyCorporate = !v;
    if (v) {
      this._bodyCorporateYes = false;
    }
  }

  get commonWaterUseYes(): boolean {
    return this._commonWaterUseYes;
  }

  set commonWaterUseYes(v: boolean) {
    this._commonWaterUseYes = v;
    this.workrequestDetails.commonWaterUse = v;
    if (v) {
      this._commonWaterUseNo = false;
    }
  }

  get commonWaterUseNo(): boolean {
    return this._commonWaterUseNo;
  }

  set commonWaterUseNo(v: boolean) {
    this._commonWaterUseNo = v;
    this.workrequestDetails.commonWaterUse = !v;
    if (v) {
      this._commonWaterUseYes = false;
    }
  }

  get invalidMeterSelection(): boolean {
    return this.finalTotal <= this.applicationFeeAmount;
  }

  get invalidDevelopmentTypeSelection(): boolean {
    return !(this.workrequestDetails.residentialNoCommonWater || this.workrequestDetails.residentialWithCommonWater ||
      this.workrequestDetails.commercialNoCommonWater || this.workrequestDetails.commercialWithCommonWater);
  }

  get residentialNoCommonWater(): boolean {
    return this.workrequestDetails.residentialNoCommonWater;
  }

  set residentialNoCommonWater(v: boolean) {
    this.workrequestDetails.residentialNoCommonWater = v;
    if (v) {
      this.workrequestDetails.residentialWithCommonWater = false;
      this.workrequestDetails.commercialWithCommonWater = false;
      this.workrequestDetails.commercialNoCommonWater = false;
    }
  }

  get residentialWithCommonWater(): boolean {
    return this.workrequestDetails.residentialWithCommonWater;
  }

  set residentialWithCommonWater(v: boolean) {
    this.workrequestDetails.residentialWithCommonWater = v;
    if (v) {
      this.workrequestDetails.residentialNoCommonWater = false;
      this.workrequestDetails.commercialWithCommonWater = false;
      this.workrequestDetails.commercialNoCommonWater = false;
    }
  }

  get commercialNoCommonWater(): boolean {
    return this.workrequestDetails.commercialNoCommonWater;
  }

  set commercialNoCommonWater(v: boolean) {
    this.workrequestDetails.commercialNoCommonWater = v;
    if (v) {
      this.workrequestDetails.residentialWithCommonWater = false;
      this.workrequestDetails.residentialNoCommonWater = false;
      this.workrequestDetails.commercialWithCommonWater = false;
    }
  }

  get commercialWithCommonWater(): boolean {
    return this.workrequestDetails.commercialWithCommonWater;
  }

  set commercialWithCommonWater(v: boolean) {
    this.workrequestDetails.commercialWithCommonWater = v;
    if (v) {
      this.workrequestDetails.residentialWithCommonWater = false;
      this.workrequestDetails.residentialNoCommonWater = false;
      this.workrequestDetails.commercialNoCommonWater = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/chm-form/workrequest-chm-viewmodel.ts